import { settingsApi } from '../api/settingsApi';
import type { LanguageSpecItem, UpdateLanguageSpecRequest, SyncMetaItem } from '../types/settings';
import { useBaseQuery, useBaseMutation, useInvalidateQueries } from './useBaseQuery';

export const settingsKeys = {
    all: ['settings'] as const,
    languages: () => [...settingsKeys.all, 'languages'] as const,
    syncMeta: () => [...settingsKeys.all, 'syncMeta'] as const,
};

export const useLanguages = () => {
    return useBaseQuery<LanguageSpecItem[]>(
        settingsKeys.languages(),
        () => settingsApi.getLanguages(),
        { staleTime: 30_000 },
    );
};

export const useUpdateLanguage = () => {
    const { invalidate } = useInvalidateQueries();

    return useBaseMutation<{ code: string; data: UpdateLanguageSpecRequest }, LanguageSpecItem>(
        ({ code, data }) => settingsApi.updateLanguage(code, data),
        {
            onSuccess: () => invalidate(settingsKeys.languages()),
        },
    );
};

export const useSyncMeta = () => {
    return useBaseQuery<SyncMetaItem>(
        settingsKeys.syncMeta(),
        () => settingsApi.getSyncMeta(),
        { staleTime: 15_000 },
    );
};
